exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".build-version{\r\n    position: fixed;\r\n    bottom: 10px;\r\n    left: 10px;\r\n    color: black;\r\n}\r\n\r\n\r\n\r\n.sidebar_logout,\r\n.second-level-toggle {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.sidebar-nav{\r\n    position: static;\r\n}\r\n\r\n#sidebar-wrapper{\r\n    top: 3px;\r\n    margin-top: 0 !important;\r\n    position: absolute !important;\r\n    overflow: hidden !important;\r\n    z-index: unset !important;\r\n}\r\n\r\n.sidebar-nav li a:active {\r\n    background: #6b7d8d !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.component.css
// module id = 1015
// module chunks = 1